import type { Passenger } from '@bambi/api-client/schemas';

import { formatPhoneNumber } from 'src/common/formatPhoneNumber';
import { formatFullName } from 'src/common/util/formatFullName';

export function formatPassengerLabel(passenger: Passenger) {
  const baseNameComponent = formatFullName(passenger);
  const phoneNumberComponent = passenger.phone_number
    ? ` ${formatPhoneNumber(passenger.phone_number)}`
    : '';
  const emrComponent = passenger.emr_identifier
    ? ` (EMR: ${passenger.emr_identifier})`
    : '';
  const dobComponent = passenger.dob ? ` (DOB: ${passenger.dob})` : '';
  const weightComponent = passenger.weight
    ? ` (Weight: ${passenger.weight} lb.)`
    : '';
  const bariatricComponent = passenger.needs_bariatric_transport
    ? ` (Bariatric)`
    : '';

  const textLabel = (
    baseNameComponent +
    phoneNumberComponent +
    emrComponent +
    dobComponent +
    weightComponent +
    bariatricComponent
  ).trim();

  return textLabel;
}
